import { IUnderwriterProfileSummaryData, IUnderwriterProfileSummaryResponse } from '../IUnderWriterProfileSummary';
import { eBulkRateDiscountRule } from '../eBulkRateDiscountRule';
import {
  convertIPremiumConfigResponseToIPremiumConfigData,
  IPremiumConfigData,
  IPremiumConfigResponse,
} from './IPremiumConfig';
import {
  convertIEndorsementConfigResponseToIEndorsementConfigData,
  IEndorsementConfigData,
  IEndorsementConfigResponse,
} from './IEndorsementConfig';
import {
  convertIOtherTitleFeeConfigurationResponseToIOtherTitleFeeConfigurationData,
  IOtherTitleFeeConfigurationData,
  IOtherTitleFeeConfigurationResponse,
} from './IOtherTitleFeeConfiguration';
import { eRounding } from '../eRounding';
import {
  convertISimultaneousIssuePremiumResponseToISimultaneousIssuePremiumData,
  ISimultaneousIssuePremiumData,
  ISimultaneousIssuePremiumResponse,
} from './ISimultaneousIssuePremium';
import { eUSAState } from '../../../../ui-toolkit/enums/states';

export interface IUnderwriterProfileResponse extends IUnderwriterProfileSummaryResponse {
  sunsetDate?: string;
  premiumConfig: IPremiumConfigResponse;
  endorsementConfig: IEndorsementConfigResponse;
  simultaneousIssue?: ISimultaneousIssuePremiumResponse;
  otherTitleFeeConfig: IOtherTitleFeeConfigurationResponse[];
  premiumsAsTitleGuaranty: boolean;
  refiDiscountConfig: { reason?: string };
  bulkRateDiscount: eBulkRateDiscountRule;
}

export interface IUnderwriterProfileData extends IUnderwriterProfileSummaryData {
  sunsetDate?: string;
  premiumConfig: IPremiumConfigData;
  endorsementConfig: IEndorsementConfigData;
  simultaneousIssue?: ISimultaneousIssuePremiumData;
  otherTitleFeeConfig: IOtherTitleFeeConfigurationData[];
  premiumsAsTitleGuaranty: boolean;
  refiDiscountConfig: { reason?: string };
  bulkRateDiscount: eBulkRateDiscountRule;
}

export const convertIUnderwriterProfileResponseToIUnderwriterProfileData = ({
  premiumConfig,
  endorsementConfig,
  otherTitleFeeConfig,
  simultaneousIssue,
  ...rest
}: IUnderwriterProfileResponse): IUnderwriterProfileData => ({
  premiumConfig: convertIPremiumConfigResponseToIPremiumConfigData(premiumConfig),
  endorsementConfig: convertIEndorsementConfigResponseToIEndorsementConfigData(endorsementConfig),
  otherTitleFeeConfig: otherTitleFeeConfig.map(
    convertIOtherTitleFeeConfigurationResponseToIOtherTitleFeeConfigurationData
  ),
  simultaneousIssue: !!simultaneousIssue
    ? convertISimultaneousIssuePremiumResponseToISimultaneousIssuePremiumData(simultaneousIssue)
    : undefined,
  ...rest,
});

export const defaultUnderwriterProfileData: IUnderwriterProfileData = {
  bulkRateDiscount: eBulkRateDiscountRule.Ineligible,
  effectiveDate: '',
  endorsementConfig: {
    flatEndorsements: [],
    loanCalcEndorsements: [],
    policyCalcEndorsements: [],
  },
  otherTitleFeeConfig: [],
  premiumsAsTitleGuaranty: true,
  premiumConfig: {
    amountRounding: eRounding.Thousands,
    premiumRounding: eRounding.Thousands,
    rates: [],
  },
  refiDiscountConfig: {},
  state: eUSAState.AL,
};
